import Skeleton from '@/components/Skeleton';

function ColumnInfo() {
  return (
    <div>
      <div className="p-3 grid gap-1">
        <Skeleton
          width="20%"
          height="20px"
          className="rounded-md bg-pv-neutral-grey-100"
        />
        <Skeleton
          width="30%"
          height="20px"
          className="rounded-md bg-pv-neutral-grey-100"
        />
      </div>
      <div className="p-3 grid gap-1">
        <Skeleton
          width="20%"
          height="20px"
          className="rounded-md bg-pv-neutral-grey-100"
        />
        <Skeleton
          width="100%"
          height="20px"
          className="rounded-md bg-pv-neutral-grey-100"
        />
        <Skeleton
          width="40%"
          height="20px"
          className="rounded-md bg-pv-neutral-grey-100"
        />
      </div>
    </div>
  );
}

function SampleData({ length = 8 }) {
  return (
    <div className="divide-y divide-pv-neutral-grey-100">
      {Array.from({ length }, (_, i) => i).map((_, key) => (
        <div key={key} className="flex items-center justify-between px-4 py-3">
          <Skeleton
            width={key % 2 ? '60%' : '30%'}
            height="20px"
            className="rounded-md bg-pv-neutral-grey-100"
          />
        </div>
      ))}
    </div>
  );
}

function ViewDrillDownsLoader() {
  return (
    <div className="divide-y divide-pv-neutral-grey-100">
      {Array.from({ length: 11 }, (_, i) => i).map((_, key) => (
        <div key={key} className="flex items-center justify-between px-4 py-3">
          <Skeleton
            width={key % 2 ? '60%' : '30%'}
            height="20px"
            className="rounded-md bg-pv-neutral-grey-100"
          />
          <Skeleton
            width="16px"
            height="16px"
            className="rounded-md bg-pv-neutral-grey-100"
          />
        </div>
      ))}
    </div>
  );
}

ViewDrillDownsLoader.ColumnInfo = ColumnInfo;

ViewDrillDownsLoader.SampleData = SampleData;

export { ViewDrillDownsLoader };
